export default __webpack_public_path__ + "f8f4253f02d1fbc4bf04d0959a6e614c.svg";